import { api } from "@slapinc/slappos-backend/api";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { PageContent } from "@/components/layout/page-content";
import { PermissionGuard } from "@/components/permission-guard";
import { Spinner } from "@/components/ui/spinner";
import { DangerZone } from "@/features/organizations/components/danger-zone";
import { SettingsForm } from "@/features/organizations/components/settings-form";
import { useMe } from "@/hooks/use-me";

export const Route = createFileRoute("/(dashboard)/settings/organization")({
	component: () => (
		<PermissionGuard scope="organizations.update">
			<OrganizationSettingsPage />
		</PermissionGuard>
	),
});

function OrganizationSettingsPage() {
	const org = useQuery(api.features.organizations.web.get, {});
	const me = useMe();

	if (org === undefined) {
		return (
			<PageContent title="Organization">
				<div className="flex items-center justify-center py-12">
					<Spinner />
				</div>
			</PageContent>
		);
	}

	if (!org) return null;

	const isCreator = !!me && org.createdBy === me._id;

	return (
		<PageContent title="Organization">
			<div className="space-y-6">
				<p className="text-muted-foreground">
					Manage your organization name, business operations, loyalty program,
					and payment settings.
				</p>
				<SettingsForm org={org} />
				{isCreator && <DangerZone orgName={org.name} />}
			</div>
		</PageContent>
	);
}
